(ns minorodata.warehouse-usage.api
  (:require [mold-http.core :refer [reg-event-http]]))

(defn service-breakdown-request [_ [{:keys [from to generation]}]]
  {:http-xhrio
   {:id        :warehouse-usage-service-breakdown
    :url       "/api/usage/series/service-breakdown"
    :cb-params generation
    :params    {:from from :to to}}})

(defn service-breakdown-callback [{:keys [db]} [error resp generation]]
  (if (not= generation (get-in db [:warehouse-usage :generation]))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:warehouse-usage :service-breakdown-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:warehouse-usage :service-breakdown-status] :error)
         :dispatch-n [[:app.events/add-snack :error "Failed to load Warehouse usage data"]
                      [:app.api/log :error "Failed to load service breakdown" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:warehouse-usage :service-breakdown] (:rows resp))
                 (assoc-in [:warehouse-usage :service-breakdown-status] :loaded))}))))

(reg-event-http
  :warehouse-usage.api/fetch-service-breakdown
  service-breakdown-request
  service-breakdown-callback)


(defn user-warehouse-usage-request [_ [{:keys [from to generation]}]]
  {:http-xhrio
   {:id        :warehouse-usage-user-warehouse-usage
    :url       "/api/usage/user-warehouse-usage"
    :cb-params generation
    :params    {:from from :to to}}})

(defn user-warehouse-usage-callback [{:keys [db]} [error resp generation]]
  (if (not= generation (get-in db [:warehouse-usage :generation]))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:warehouse-usage :user-warehouse-usage-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:warehouse-usage :user-warehouse-usage-status] :error)
         :dispatch-n [[:app.events/add-snack :error "Failed to load Warehouse usage data"]
                      [:app.api/log :error "Failed to load user warehouse usage" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:warehouse-usage :user-warehouse-usage] (:rows resp))
                 (assoc-in [:warehouse-usage :user-warehouse-usage-status] :loaded))}))))

(reg-event-http
  :warehouse-usage.api/fetch-user-warehouse-usage
  user-warehouse-usage-request
  user-warehouse-usage-callback)


(defn warehouse-credits-request [_ [{:keys [from to granularity generation seq]}]]
  {:http-xhrio
   {:id        :warehouse-usage-warehouse-credits
    :url       "/api/usage/series/warehouse-credits"
    :cb-params {:generation generation :seq seq}
    :params    {:from from :to to :granularity granularity}}})

(defn warehouse-credits-callback [{:keys [db]} [error resp {:keys [generation seq]}]]
  (if (or (not= generation (get-in db [:warehouse-usage :generation]))
          (not= seq (get-in db [:warehouse-usage :warehouse-credits-seq])))
    {}
    (case (:status error)
      403 {:db (assoc-in db [:warehouse-usage :warehouse-credits-status] :not-provisioned)}

      401 {}

      (if (some? error)
        {:db         (assoc-in db [:warehouse-usage :warehouse-credits-status] :error)
         :dispatch-n [[:app.events/add-snack :error "Failed to load Warehouse usage data"]
                      [:app.api/log :error "Failed to load warehouse credits" (select-keys error [:status :status-text])]]}

        {:db (-> db
                 (assoc-in [:warehouse-usage :warehouse-credits] (:rows resp))
                 (assoc-in [:warehouse-usage :warehouse-credits-status] :loaded))}))))

(reg-event-http
  :warehouse-usage.api/fetch-warehouse-credits
  warehouse-credits-request
  warehouse-credits-callback)
